import * as React from "react";
import {
  TextField,
  DateField,
  TextInput,
  SelectInput,
  EditButton,
} from "react-admin";
import { Datagrid, IfCanAccess, List } from "src/enterprise/ra-rbac";

const listFilters = [
  <TextInput source="search" label="Search" alwaysOn />,
  <SelectInput
    source="type"
    choices={[
      { id: "type", name: "Type" },
      { id: "region", name: "Region" },
    ]}
  />,
];

export const MakerFilterList = (props) => {
  return (
    <List {...props} filters={listFilters} queryOptions={{ cacheTime: 0 }}>
      <Datagrid>
        <TextField source="id" />
        <TextField source="code" />
        <TextField source="name" />
        <TextField source="type" />
        <DateField source="created_at" label="Created At" />
        <IfCanAccess action="edit">
          <EditButton />
        </IfCanAccess>
      </Datagrid>
    </List>
  );
};
